module.exports = __webpack_public_path__ + "static/img/dashed.274a020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashed.png
// module id = UGwz
// module chunks = 72